var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RouterLink',{staticClass:"flex items-center p-2 -mx-2 rounded-md text-gray-700 hover:bg-gray-200",attrs:{"exact-active-class":"bg-indigo-100 text-blue-500 hover:bg-indigo-100","to":_vm.to}},[_vm._t("icon"),_c('span',{staticClass:"text-lg font-medium ml-4"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }